import { defineMessages, FormattedMessage } from 'react-intl';

const prefix = 'salesTaxBadge';

export const VATIncluded = (
  <FormattedMessage
    defaultMessage='Incl. Sales Tax'
    id={`${prefix}.vatIncluded`}
  />
);

export const VATExcluded = (
  <FormattedMessage
    defaultMessage='Excl. Sales Tax'
    id={`${prefix}.vatExcluded`}
  />
);
export const vatMessages = defineMessages({
  inclSalesTax: {
    id: `price.tax.included`,
    defaultMessage: 'Incl. Sales Tax',
  },
  exclSalesTax: {
    id: `price.tax.excluded`,
    defaultMessage: 'Excl. Sales Tax',
  },
  inclGST: {
    id: `price.gst.included`,
    defaultMessage: 'Incl. GST',
  },
  vatIncluded: {
    id: `price.vat.included`,
    defaultMessage: 'Vat included',
  },
  consumptionIncluded: {
    id: `price.consumption.included`,
    defaultMessage: 'Consumption Tax Included',
  },
  gstIncluded: {
    id: `price.gst.included`,
    defaultMessage: 'GST included',
  },
});

export const vatMessagesDetail = defineMessages({
  inclSalesTax: {
    id: `price.tax.included.detail`,
    defaultMessage: 'inclusive of sales tax',
  },
  exclSalesTax: {
    id: `price.tax.excluded.detail`,
    defaultMessage: 'exclusive of sales tax',
  },
  inclGST: {
    id: `price.gst.included.detail`,
    defaultMessage: 'inclusive of GST',
  },
  vatIncluded: {
    id: `price.vat.included.detail`,
    defaultMessage: 'Vat included',
  },
  consumptionIncluded: {
    id: `price.consumption.included.detail`,
    defaultMessage: 'inclusive of Consumption Tax',
  },
  gstIncluded: {
    id: `price.gst.included.detail`,
    defaultMessage: 'GST included',
  },
});

export const taxMessagesLabel = defineMessages({
  vat: {
    id: `price.tax.vat`,
    defaultMessage: 'VAT',
  },
  consumption: {
    id: `price.tax.consumption`,
    defaultMessage: `Consumption Tax`,
  },
  gst: {
    id: `price.tax.gst`,
    defaultMessage: 'GST',
  },
  salesTax: {
    id: `price.tax.salesTax`,
    defaultMessage: 'Sales tax',
  },
});
